import { useEmblaCarousel } from 'embla-carousel/react';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HouseTypePrice from '../HouseTypePrice';
import { StyledCarousel, Container, Slide, DotList, Dot } from './Carousel.styles';
import PropTypes from 'prop-types';
import { useRecursiveTimeout } from './useRecursiveTimeout';

const Carousel = ({ types }) => {

    const { t } = useTranslation();




    const [emblaRef, emblaApi] = useEmblaCarousel({ 
        loop: false, 
        align: 'start', 
        containScroll: 'trimSnaps', 
        slidesToScroll: 1
    });

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [scrollSnaps, setScrollSnaps] = useState([]);


    // So we can scroll to a item manually.
    const scrollTo = useCallback((index) => emblaApi && emblaApi.scrollTo(index), [
        emblaApi
    ]);
    const autoplay = useCallback(() => {
        if (!emblaApi) return;

        if (emblaApi.canScrollNext()) {
            emblaApi.scrollNext();
        } else {
            emblaApi.scrollTo(0);
        }
    }, [emblaApi]);

    const { play, stop } = useRecursiveTimeout(autoplay, 2000);

    /**
     * Used for:
     * 1. Setting the embla scroll snaps (basically informtion about slides
     */ 
    const onSelect = useCallback(() => {
        if (!emblaApi) return;
        setSelectedIndex(emblaApi.selectedScrollSnap());
        // setPrevBtnEnabled(embla.canScrollPrev());
        emblaApi.on("pointerDown", stop);
        // setNextBtnEnabled(embla.canScrollNext());
    }, [emblaApi, setSelectedIndex, stop]);




      
    

    const scrollNext = useCallback(() => {
        if (!emblaApi) return;
        emblaApi.scrollNext();
        stop();
    }, [emblaApi, stop]);
    
    const scrollPrev = useCallback(() => {
        if (!emblaApi) return;
        emblaApi.scrollPrev();
        stop();
    }, [emblaApi, stop]);


      useEffect(() => {
        play();
      }, [play]);


    useEffect(() => {
        if (!emblaApi) return;
        onSelect();
        setScrollSnaps(emblaApi.scrollSnapList());
        emblaApi.on("select", onSelect);
    }, [emblaApi, setScrollSnaps, onSelect]);



    return (
        <StyledCarousel ref={ emblaRef }>
            <Container>
                { types.map( (item, key) => (
                    <HouseTypePrice key={ item.name }
                        style={ {minWidth: '100%'} }
                        image={ item.image} 
                        title={ t(`location.houseTypes.${ item.name }`) }  
                        value={ item.average } 
                    />
                ))}
                
            </Container>

            <DotList>
                { scrollSnaps.map((_, index) => (
                <Dot
                    key={index}
                    isActive={index === selectedIndex}
                    onClick={() => scrollTo(index)}
                />
                ))}
            </DotList>

        </StyledCarousel>
    )
}


Carousel.propTypes = {
    types: PropTypes.array.isRequired,
}

export default Carousel;